var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src)?_c('div',{class:['text-center', _vm.wrapperClass]},[_c('img',{class:['w-full max-w-full', _vm.imageClass],attrs:{"src":_vm.src,"alt":_vm.alt}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }